import { createFileRoute } from '@tanstack/react-router';

import { CitationBrowse } from '@/module/Author/Citation/CitationBrowse';

export const Route = createFileRoute(
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { translationId } = Route.useParams();
  return <CitationBrowse publicationId={translationId} />;
}
